import * as React from 'react';
import Select from 'react-select';
import moment from 'moment';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Theme } from '@mui/material/styles';

// Menu items
// The order listed is the order they should render (I realize JSON doesn't gauarantee
// order, but untill it's a problem whatever)

interface IProps {
    handleSwitchTeams: (slug: string) => void;
    setSelectedInsightRow: Function;
    menuTitle: string;
    itemWidth: string;

    config: any;

    user: User;
    org: OrgState;
    app: AppState;

    echoOpen?: (isOpen: boolean) => void;
    theme?: Theme;
}

interface Refs {
    [key: string]: React.Component<any, any>;
    periodDropdown: Select;
}

interface IState {
    isMenuOpen: boolean;
}


export class TeamsDropdown extends React.Component<IProps, IState> {
    state: IState = {
        isMenuOpen: false
    }

    refs: Refs;

    componentDidMount() {
        ((typeof window !== "undefined") ? document : {}).addEventListener("keydown", this.handleEscapePress, false);
    }

    componentWillUnmount() {
        ((typeof window !== "undefined") ? document : {}).removeEventListener("keydown", this.handleEscapePress, false);
    }

    handleEscapePress = (event) => {
        if (event.keyCode === 27) {
            this.setState({
                isMenuOpen: false
            });
        }
    }

    toggleOpen = () => {
        if (this.props.echoOpen) {
            this.props.echoOpen(!this.state.isMenuOpen);
        }

        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    calculateClassName = () => {
        return "react-select-dd";
    }

    calculateMenuProvider = (provided) => {
        const { theme } = this.props;
        return {
            ...provided,
            position: 'absolute',
            width: '220px',
            zIndex: theme?.custom?.menuZIndex,
            marginTop: 0,
            boxShadow: theme?.custom?.menuBoxShadow,
            maxHeight: '400px',
        }
    }

    calculateControlProvider = (provided, state) => {
        const { theme } = this.props;
        return {
            ...provided,
            border: 'none',
            backgroundColor: 'transparency',
            outline: 'none',
            position: 'relative',
            boxShadow: 'none',
            paddingTop: '0px',
            marginLeft: '4px',
            marginRight: '8px',
            paddingBottom: '0px',
            minHeight: '0',
            ':hover': {
                color: theme?.custom?.mainButtonHighlight,
            },
        }
    }

    calculateStyleProvider = (provided, state) => {
        const { theme } = this.props;
        return {
            ...provided,
            color: 'black',
            backgroundColor: 'white',
            cursor: 'pointer',
            position: 'static',
            overflow: 'hidden',
            lineHeight: '20px',
            '&:hover': {
                backgroundColor: theme?.custom?.hoverOptionColor
            }
        }
    }

    calculateValueContainer = (provided, state) => {
        return {
            ...provided, 
            padding: '0px',
            fontSize: '20px'
        }
    }

    calculateMenuList = (provided, state) => {
        return {
            ...provided,
            maxHeight: '400px',
        }
    }

    renderInput = (innerProps) => {
        return (
            <span
                style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                }}
                onTouchStart={() => {
                    this.toggleOpen();
                }}
                onClick={() => {
                    this.toggleOpen();
                }}
            >
                <span
                    style={{
                        width: "fit-content",
                        maxWidth: "350px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {this.props?.menuTitle}
                </span>
                <ExpandMoreIcon sx={{ color: "inherit !important" }} />
            </span>
        );
    }

    renderPlaceholder = (innerProps) => {
        return <span></span>
    }

    renderDropdownIndicator = (innerProps) => {
        return <span onClick={() => {
            this.toggleOpen();
        }} style={{}}>
            
        </span>
    }

    render() {
        const {
            isMenuOpen
        } = this.state;
        const { theme } = this.props;
        const styleProvider = {
            option: this.calculateStyleProvider,
            control: this.calculateControlProvider,
            menu: this.calculateMenuProvider,
            valueContainer: this.calculateValueContainer,
            menuList: this.calculateMenuList,
        }

        const componentOverrides = {
            Input: this.renderInput,
            Placeholder: this.renderPlaceholder,
            DropdownIndicator: this.renderDropdownIndicator,
            SingleValue: this.renderPlaceholder,
            IndicatorSeparator: this.renderPlaceholder
        }

        const clickAwayTracker = <span onClick={() => {
            if (this.props.echoOpen) {
                this.props.echoOpen(false);
            }
            
            this.setState({
                isMenuOpen: false
            });
        }} style={{ position: 'fixed', top: '0px', left: '0px', height: '100vh', width: '100vw', zIndex: theme?.custom?.menuClickAwayZIndex }} />

        return <span style={{ display: 'block' }}>
            {isMenuOpen ? clickAwayTracker : undefined}
            <Select
                menuIsOpen={isMenuOpen}
                components={componentOverrides}
                selected={undefined}
                className={this.calculateClassName()}
                styles={styleProvider}
                options={this.props.config}
                openMenuOnFocus={true}
                onMenuClose={() => {
                    if (this.props.echoOpen) {
                        this.props.echoOpen(false);
                    }
                }}
                onChange={(options: any) => {
                    this.props.handleSwitchTeams(options.value)
                    this.props.setSelectedInsightRow(undefined)
                    this.toggleOpen();
                }}
            />
        </span>
    }
}
